import { render, staticRenderFns } from "./StatisticLayout.vue?vue&type=template&id=0a80fd32&scoped=true&"
import script from "./StatisticLayout.vue?vue&type=script&lang=js&"
export * from "./StatisticLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a80fd32",
  null
  
)

export default component.exports